// ADR-024 (decision de Federico del 29/09, ratificada el 03/10): el portal no
// exige TOTP al operador de proveedor. Si la cuenta lo tiene, Cognito lo
// sigue pidiendo en el login; si no, entra sin el. Login y renovacion usan
// esta misma constante (estable: useLoginFlow la usa como dependencia).
import type { PoliticaMfa } from "@ucorp/web-auth";

export const POLITICA_MFA: PoliticaMfa = { exigeTotp: false };
